import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useSWR from 'swr';

import { queryParams, withQueryParams } from '@shared/commonFunctions';
import { LoaderBackdrop } from '@shared/components/LoaderBackdrop';
import { SERVICES } from '@shared/constants/apiConfig';
import { PageWrapper } from '@shared/styledComponents';

export const RegistrationInfo = () => {
  const navigate = useNavigate();
  const params = queryParams();

 const errors =  params.error ?? '';
 const error_Description = params.error_Description ?? '';
 
  const { data, error } = useSWR(
    `${SERVICES.ASSET}/assets/title/getAccessToken?code=${params.code}&error=${errors}&error_Description=${error_Description}&state=${params.state}`,
  );

  useEffect(() => {
      let id = '';
      let assetId = '';
    if (params.state) {
      const state = params.state;
      const stateParamsArray = state.split('&').map((x: string) => x.split('='));
      const stateParamsDictionary: { [key: string]: string } = stateParamsArray.reduce((acc: { [x: string]: string; }, x: string[]) => {
        acc[x[0]] = x[1];
        acc[x[2]] = x[3];
        acc[x[4]] = x[5];
        return acc;
    }, {});
      if ('id' in stateParamsDictionary) {
        id = stateParamsDictionary['id'];
      }
      if ('assetId' in stateParamsDictionary) {
        assetId = stateParamsDictionary['assetId'];
      }
    }
    if (data && !error) {
      const route = withQueryParams('/contact-manager', {tab: 1, id: id, assetId: assetId });
      navigate(route);
    }
  }, [data, error]);

  return (
    <PageWrapper>
      <LoaderBackdrop open={true} loaderText={'Generating access token...'} />
    </PageWrapper>
  );
};
